import React from 'react'

interface IconProps {
  className?: string
}

const ClockBars = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 12.3865 20.9757 12.7669 20.9286 13.1398C20.8595 13.6877 21.2476 14.188 21.7955 14.2571C22.3435 14.3263 22.8437 13.9382 22.9129 13.3902C22.9704 12.9345 23 12.4705 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C12.4781 23 12.9495 22.9694 13.4123 22.9101C13.9601 22.8398 14.3472 22.3388 14.2769 21.791C14.2066 21.2432 13.7056 20.8561 13.1578 20.9263C12.7792 20.9749 12.3928 21 12 21C7.02944 21 3 16.9706 3 12ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V12C11 12.3788 11.214 12.725 11.5528 12.8944L15.2912 14.7636C15.7851 15.0106 16.3858 14.8104 16.6328 14.3164C16.8798 13.8224 16.6796 13.2217 16.1856 12.9748L13 11.382V6ZM20.25 16C20.25 15.4477 19.8023 15 19.25 15C18.6977 15 18.25 15.4477 18.25 16V22C18.25 22.5523 18.6977 23 19.25 23C19.8023 23 20.25 22.5523 20.25 22V16ZM23.25 18.25C23.25 17.6977 22.8023 17.25 22.25 17.25C21.6977 17.25 21.25 17.6977 21.25 18.25V22C21.25 22.5523 21.6977 23 22.25 23C22.8023 23 23.25 22.5523 23.25 22V18.25ZM17.25 19.75C17.25 19.1977 16.8023 18.75 16.25 18.75C15.6977 18.75 15.25 19.1977 15.25 19.75V22C15.25 22.5523 15.6977 23 16.25 23C16.8023 23 17.25 22.5523 17.25 22V19.75Z"
      fill="currentColor"
    />
  </svg>
)

export default ClockBars
